import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardRepository } from '../../../infrastructure/repositories/dashboard.repository';
import { GetDashboardPreferencesResult } from './get-dashboard-preferences.result';

@Injectable({ providedIn: 'root' })
export class GetDashboardPreferencesUseCase {
  private readonly _repository = inject(DashboardRepository);

  public execute(): Observable<GetDashboardPreferencesResult> {
    return this._repository.getMe().pipe(map((preferences) => ({ preferences })));
  }
}
